import {$qsAll} from '../../@shared/ts/dom';
import {Feature} from './features';
import {FeatureFlag} from '../../@type/features';
import {getCheckoutForm} from './checkout';

function installCaptchaScript() {
	const script = document.createElement('script');
	script.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=' + Feature.metadata(FeatureFlag.BOT_PROTECTION, 'site_key'));

	script.async = true;
	script.defer = true;

	document.body.appendChild(script);
}

async function insertCaptchaFields(checkoutForm: HTMLFormElement | null = null): Promise<void> {
	if (!checkoutForm) {
		checkoutForm = getCheckoutForm();
	}

	if (!Feature.enabled(FeatureFlag.BOT_PROTECTION)) {
		return;
	}

	return new Promise<void>(resolve => {
		grecaptcha.ready(async () => {
			try {
				const token = await grecaptcha.execute(Feature.metadata(FeatureFlag.BOT_PROTECTION, 'site_key') ?? '', {action: 'NATIVE_CHECKOUT'});

				const $nativeCheckoutFlag = document.createElement('input');
				$nativeCheckoutFlag.type = 'hidden';
				$nativeCheckoutFlag.name = 'peachpay_captcha_token';
				$nativeCheckoutFlag.value = token;
				checkoutForm?.insertAdjacentElement('beforeend', $nativeCheckoutFlag);
			} catch {
				// Do no harm. The admin side will display an error if this is required.
			}

			resolve();
		});
	});
}

function cleanupCaptchaFields() {
	$qsAll('input[name="peachpay_captcha_token"]', $el => {
		$el.remove();
	});
}

export {
	installCaptchaScript,
	insertCaptchaFields,
	cleanupCaptchaFields,
};
